module.exports = __webpack_public_path__ + "static/hero-right-2167f50231bddb012965fd9e642ddb06.jpg";